import axios from 'axios';

import { BACKEND_URL, apiPath } from '../../../config/apiBase';
export const API = apiPath('/api/tickets/workforce');
export const ASSISTANT_API = apiPath('/api/tickets/assistant');

export function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    withCredentials: true,
    headers: { Authorization: `Bearer ${token}` },
  };
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  if (s < 60) return `${s}s`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const rem = s % 60;
  if (h > 0) return rem ? `${h}h ${m}m ${rem}s` : `${h}h ${m}m`;
  return rem ? `${m}m ${rem}s` : `${m}m`;
}

/** Live Active Time: backend snapshot + seconds since board was generated. */
export function liveActiveSeconds(member, boardGeneratedAt, nowMs = Date.now()) {
  const base = Math.max(0, Math.floor(Number(member?.active_seconds) || 0));
  if (member?.availability !== 'busy') return base;
  if (!boardGeneratedAt) return base;
  const fetchedAt = new Date(boardGeneratedAt).getTime();
  if (Number.isNaN(fetchedAt)) return base;
  const extra = Math.max(0, Math.floor((nowMs - fetchedAt) / 1000));
  return base + extra;
}

export const thStyle = { padding: '6px 8px', fontSize: '12px', fontWeight: '600', color: '#374151' };
export const tdStyle = { padding: '6px 8px', fontSize: '12px', color: '#111827' };

export async function fetchLiveBoard() {
  const res = await axios.get(`${API}/live`, authHeaders());
  return res.data;
}

export async function fetchWorkforceUsers() {
  const res = await axios.get(`${API}/users`, authHeaders());
  return res.data;
}

export async function fetchUserMonth(userId, year, month, date) {
  const res = await axios.get(`${API}/users/${userId}/month`, {
    ...authHeaders(),
    params: {
      year,
      month,
      ...(date ? { date } : {}),
    },
  });
  return res.data;
}

/** Prefer backend event_label; fall back to status transition text. */
export function formatWorkEventLabel(ev) {
  if (ev?.event_label) return ev.event_label;
  if (ev?.event_type === 'status_changed') {
    const from = (ev.from_status || ev.details?.from || '').replace(/_/g, ' ');
    const to = (ev.to_status || ev.details?.to || '').replace(/_/g, ' ');
    if (to) {
      const a = from ? from.replace(/\b\w/g, (c) => c.toUpperCase()) : '—';
      const b = to.replace(/\b\w/g, (c) => c.toUpperCase());
      return `${a} → ${b}`;
    }
  }
  return (ev?.event_type || 'event').replace(/_/g, ' ');
}

export async function askAssistant(question) {
  const res = await axios.post(`${ASSISTANT_API}/query`, { question }, authHeaders());
  return res.data;
}
